import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineGroupDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineGroup/GetDetail?` + params, null);

export const GetMedicineGroupList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineGroup/GetList?` + params, null);

export const CreateMedicineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGroup/Create`, data);

export const UpdateMedicineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGroup/Update`, data);

export const DeleteMedicineGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGroup/Delete`, data);






